<template>
  <div>
    <CContainer>
      <CRow class="justify-content-center mt-4">
        <CCol md="12 text-center">
          <h1 class="mb-4">{{ $t("quick_reference.page_title") }}</h1>
          <div v-if="trainings && trainings.reference_cards">
            <iframe
              :src="trainings.reference_cards[user.role.name]"
              class="trainings-iframe"
            />
          </div>
          <div v-else>{{ $t("quick_reference.no_data") }}</div>
        </CCol>
      </CRow>
    </CContainer>
  </div>
</template>
<script>
import { mapGetters } from "vuex"

export default {
  name: "QuickReference",
  computed: {
    ...mapGetters({
      trainings: "updates/trainings",
      user: "authentication/user"
    })
  },
  created() {
    this.$store.dispatch("updates/getTrainings")
  }
}
</script>
